// eslint-disable-next-line no-useless-escape
export const UrlRegex = '^(https?://)([\\da-z.-]+)\.([a-z.]{2,6})[/\\w %.#-]*/?(\\?([\\w%/_]+=[\\w%/_]+&?)+)?$';
